import React, { useCallback } from "react";
import { AgGridReact } from "ag-grid-react";

import TableControls from "./TableControls";

import "./agclient.css";

const AgGridClient = ({
  rowData = [],
  columnDefs = [],
  pagination = true,
  paginationPageSize = 5,
  paginationPageSizeSelector = [5, 10, 20, 50, 100],
  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
  },
  gridOptions = {},
  onGridReady = null,
  className = "",
  selectedColumns = [],
  defaultVisibleColumns = [],
  onColumnSelectionChange = () => { },
  allColumnDefs = [],

  gridApi,

  actionButton,

  ...otherProps
}) => {
  const defaultGridOptions = {
    pagination,
    paginationPageSize,
    paginationPageSizeSelector,
    defaultColDef,
    rowSelection: "single",
    suppressRowClickSelection: false,
    ...gridOptions,
  };

  const resetFiltersFunction = useCallback(() => {
    if (gridApi) {
      gridApi.setFilterModel(null);
      gridApi.resetColumnState();
    }
  }, [gridApi]);

  return (
    <div
      className="client-side-datatable"
      style={{
        flex: "1 1 auto",
        width: "100%",
        minHeight: "400px",
        height: "100%",
      }}
    >
      <TableControls
        resetFiltersFunction={resetFiltersFunction}
        columnDefs={allColumnDefs.length > 0 ? allColumnDefs : columnDefs}
        selectedColumns={selectedColumns}
        defaultVisibleColumns={defaultVisibleColumns}
        onColumnSelectionChange={onColumnSelectionChange}
        actionButton={actionButton}
      />

      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        gridOptions={defaultGridOptions}
        onGridReady={onGridReady}
        suppressColumnVirtualisation={true}
        rowHeight={36}
        {...otherProps}
      />
    </div>
  );
};

export default AgGridClient;
